import React from 'react';
import _ from 'lodash';

import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import {
    Search as SearchIcon,
} from '@material-ui/icons';
import {
    createStyles, WithStyles, Paper, TableHead
} from '@material-ui/core';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import moment from 'moment';

const styles = (theme: Theme) => createStyles({
    textSM: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgb(51, 51, 51)'
    },
    searchIcon: {
        fill: theme.palette.text.secondary,
        opacity: 0.5
    },
    root: {
        width: '100%',
        padding: 16
    },
    tableFooter: {
        width: '100%'
    },
    table: {
        minWidth: 500,
        '& td': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    tableWrapper: {
        overflowX: 'auto',
        background: '#FFFFFF',
        boxSizing: 'border-box',
        borderRadius: 4
    },
    tableHead: {
        background: '#F4F4F4',
        border: '1px solid #DFDFDF',
        boxSizing: 'border-box',
        borderRadius: '4px 4px 0px 0px',
        height: 75
    },
    tableCell: {
        border: '1px solid #DFDFDF',
        maxWidth: 130,
        padding: '30px 20px',
    }
});


interface ReportsTableProps extends WithStyles<typeof styles> {
    classes: any,
    questions: any[],
    tests: any[],
    total: number,
    isNextDisabled: boolean,
    isPreviousDisabled: boolean,
    loadNextList: Function,
    loadPreviousList: Function,
    loadList: Function,
    contentType: string,
}

const ReportsTable = (props: ReportsTableProps) => {
    const {
        classes,
        questions,
        tests,
        contentType,
        total,
        loadList,
    } = props;
    //@ts-ignore
    const [page, setPage]= React.useState(0);

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage)
        loadList(newPage)
    };

    const handleChangeRowsPerPage = (event: any) => {
        // this.setState({ page: 0, rowsPerPage: event.target.value });
    };
    const tableData = contentType === 'question' ? questions : tests

    return (
        <>
            <Paper className={classes.root} elevation={0}>
                <div className={classes.tableWrapper}>
                    {

                    }
                    <Table classes={{ root: classes.table }} padding="checkbox">
                        <TableHead classes={{ root: classes.tableHead }}>
                            <TableRow>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">S.No.</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center" >Created By</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                    {contentType === 'question' ? 'Question ID' : 'Test ID'}
                                </TableCell>
                                {
                                    contentType === 'question' &&
                                    <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                        Question Type
                                    </TableCell>
                                }

                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">All Tag</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">Status</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">Created Date</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">First Publish Date</TableCell>
                                <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">Update Date</TableCell>
                                {
                                    contentType === 'test' &&
                                    <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">Goal</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => ( For Use */}
                            {

                                tableData.map((cell: any, index: number) => {
                                    return <TableRow key={1}>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} component="th" scope="row" align="center">
                                            {index + 1}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {`${cell.firstName} ${cell.lastName}`}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {cell.contentId}
                                        </TableCell>
                                        {
                                            contentType === 'question' &&
                                            <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                                {cell.questionType}
                                            </TableCell>
                                        }

                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {cell.tags.join(" ,")}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {cell.status}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {moment(cell.createdAt).format('D MMMM  YYYY')}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {moment(cell.firstPublishDate).format('D MMMM  YYYY')}
                                        </TableCell>
                                        <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                            {moment(cell.updatedAt).format('D MMMM  YYYY')}
                                        </TableCell>
                                        {
                                            contentType === 'test' &&
                                            <TableCell classes={{ head: classes.textSM, root: classes.tableCell }} align="center">
                                                {cell.goalName}
                                            </TableCell>
                                        }
                                    </TableRow>
                                })
                            }
                            {/* {emptyRows > 0 && (
                                <TableRow style={{ height: 48 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                                )} */}
                        </TableBody>
                        <TableFooter classes={{ root: classes.tableFooter }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10]}
                                    //colSpan={12}
                                    count={total}
                                    rowsPerPage={10}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onChangePage={handleChangePage}
                                    //onChangeRowsPerPage={handleChangeRowsPerPage}
                                    //ActionsComponent={TablePaginationActionsWrapped} //For use
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        </>

    );
};

export default withStyles(styles)(ReportsTable);